import { NgModule, Optional, SkipSelf } from '@angular/core';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { EInvoiceService } from './services/e-invoice.service';
import { AuthService } from './util/auth.service';
import { CalcService } from './util/calc.service';
import { CurrencyMaskService } from './util/currency-mask.service';
import { DocNavService } from './util/doc-nav.service';
import { FcwidgetService } from './util/fcwidget.service';
import { FormService } from './util/form.service';
import { QueryParamsService } from './util/query-params.service';
import { ReportNavService } from './util/report-nav.service';
import { ReportingService } from './util/reporting.service';
import { TreeDataService } from './util/tree-data.service';

@NgModule({
  providers: [
    FormService,
    FcwidgetService,
    CurrencyMaskService,
    TreeDataService,
    AuthService,
    ReportingService,
    CalcService,
    DocNavService,
    ReportNavService,
    QueryParamsService,
    EInvoiceService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
